module.exports = __webpack_public_path__ + "static/media/gopost-logo.069f9862.png";